import React, { useContext } from 'react';
import classnames from 'classnames';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Details from '../../DeviationViews/Details';
import TextualContent from '../../DeviationViews/TextualContent';
import StageBackground from '../../DeviationBackground/StageBackground';
import { useDeviationViewContext } from '../../Context/DeviationViewContext';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { DeviationTypes } from '../../types/deviation';
import { ScreenSizeContext } from '../../Measured';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import DesktopLayout from '../_partials/DesktopLayout';
import PanelPopup from '../_partials/PanelPopup';
import MonetizationStrip from '../../MonetizationStrip';
import s from './DesktopTextualPage.scss';
const DesktopTextualPage = ({ deviation  })=>{
    var _deviation_textContent, _deviation_extended, _deviation_extended1;
    const { isTheater  } = useDeviationViewContext();
    const isLegacyJournal = getDeviationType(deviation) === DeviationTypes.JOURNAL && ((_deviation_textContent = deviation.textContent) === null || _deviation_textContent === void 0 ? void 0 : _deviation_textContent.html.type) === 'writer';
    const isLegacyView = isLegacyJournal && !((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.journalSkinFullwidth);
    const isFullWidthView = isLegacyJournal && ((_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.journalSkinFullwidth);
    const contentClassName = classnames(s['content'], isLegacyView && s['is-legacy-journal'], isFullWidthView && s['is-fullwidth-skin']);
    const { width: screenSize  } = useContext(ScreenSizeContext);
    return /*#__PURE__*/ React.createElement(DesktopLayout, {
        className: classnames(isTheater && s['theater']),
        deviation: deviation,
        stageContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ArtStage, {
            deviation: deviation
        }), /*#__PURE__*/ React.createElement("div", {
            className: s['strip-tier-promotion-wrapper']
        }, /*#__PURE__*/ React.createElement(MonetizationStrip, {
            className: s['strip-tier-promotion'],
            deviation: deviation
        })), /*#__PURE__*/ React.createElement("div", {
            className: contentClassName
        }, /*#__PURE__*/ React.createElement(ActionBar, {
            deviation: deviation
        })), /*#__PURE__*/ React.createElement(PanelPopup, {
            deviation: deviation,
            className: s['large-popover'],
            actionBarType: "primary"
        }), /*#__PURE__*/ React.createElement("div", {
            className: contentClassName
        }, /*#__PURE__*/ React.createElement(TextualContent, {
            deviation: deviation
        }))),
        metaContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Details, {
            className: contentClassName,
            deviation: deviation
        }), /*#__PURE__*/ React.createElement(UserGiftSaleBanner, {
            user: deviation.author
        })),
        backgroundContent: /*#__PURE__*/ React.createElement(StageBackground, {
            deviation: deviation,
            width: Math.max(screenSize, 780)
        }),
        withSecondaryActionBar: true
    });
};
DesktopTextualPage.displayName = 'DesktopTextualPage';
export default DesktopTextualPage;
